module.exports = __webpack_public_path__ + "img/otkritost-mob-2.d1cf60dc.png";